import type { Theme } from '@mui/material/styles'
import { alpha } from '@mui/material'
import type { ScalesAndLinesSettings } from '../components/chartV2/chart.typings'

export const defaultScalesAndLinesSettings = {
    showPlusButton: true,
    showCountdown: true,
    alignLabels: true,
    showHighLowLine: false,
    showHighLowLabel: false,
    highLowLineColorOpacity: 1,
    showPrevDayHighLowLine: false,
    showPrevDayHighLowLabel: false,
    prevDayHighLowLineColor: '#9c6b30',
    prevDayHighLowLineColorOpacity: 1,
    showCurrentDayHighLowLine: false,
    showCurrentDayHighLowLabel: false,
    currentDayHighLowLineColorOpacity: 1,
    showIndicatorValue: true,
    showIndicatorLabel: true,
    showPrevDayCloseLine: false,
    showPrevDayCloseLabel: false,
    prevDayCloseLineColor: '#555555',
    prevDayCloseLineColorOpacity: 1,
    showSymbolLine: true,
    showSymbolValue: true,
    showTodayOpenLine: false,
    showTodayOpenLabel: false,
    todayOpenLineColor: '#2196F3',
    todayOpenLineColorOpacity: 1,
}

export const getDefaultHighLowLineColor = (theme: Theme) =>
    theme.palette.mode === 'dark' ? '#142e61' : '#e3eefd'

export const getEffectiveHighLowLineColor = (
    settings: Pick<ScalesAndLinesSettings, 'highLowLineColor' | 'highLowLineColorOpacity'> | undefined,
    theme: Theme
) => {
    const color = settings?.highLowLineColor ?? getDefaultHighLowLineColor(theme)
    const opacity = settings?.highLowLineColorOpacity ?? defaultScalesAndLinesSettings.highLowLineColorOpacity
    return alpha(color, opacity)
}

export const getEffectivePrevDayCloseLineColor = (
    settings: Pick<ScalesAndLinesSettings, 'prevDayCloseLineColor' | 'prevDayCloseLineColorOpacity'> | undefined
) => {
    const color = settings?.prevDayCloseLineColor ?? defaultScalesAndLinesSettings.prevDayCloseLineColor
    const opacity = settings?.prevDayCloseLineColorOpacity ?? defaultScalesAndLinesSettings.prevDayCloseLineColorOpacity
    return alpha(color, opacity)
}

export const getEffectivePrevDayHighLowLineColor = (
    settings: Pick<ScalesAndLinesSettings, 'prevDayHighLowLineColor' | 'prevDayHighLowLineColorOpacity'> | undefined
) => {
    const color = settings?.prevDayHighLowLineColor ?? defaultScalesAndLinesSettings.prevDayHighLowLineColor
    const opacity = settings?.prevDayHighLowLineColorOpacity ?? defaultScalesAndLinesSettings.prevDayHighLowLineColorOpacity
    return alpha(color, opacity)
}

export const getEffectiveCurrentDayHighLowLineColor = (
    settings: Pick<ScalesAndLinesSettings, 'currentDayHighLowLineColor' | 'currentDayHighLowLineColorOpacity'> | undefined,
    theme: Theme
) => {
    const color = settings?.currentDayHighLowLineColor ?? getDefaultHighLowLineColor(theme)
    const opacity = settings?.currentDayHighLowLineColorOpacity ?? defaultScalesAndLinesSettings.currentDayHighLowLineColorOpacity
    return alpha(color, opacity)
}

export const getEffectiveTodayOpenLineColor = (
    settings: Pick<ScalesAndLinesSettings, 'todayOpenLineColor' | 'todayOpenLineColorOpacity'> | undefined
) => {
    const color = settings?.todayOpenLineColor ?? defaultScalesAndLinesSettings.todayOpenLineColor
    const opacity = settings?.todayOpenLineColorOpacity ?? defaultScalesAndLinesSettings.todayOpenLineColorOpacity
    return alpha(color, opacity)
}
